'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ChartOptions = require('./ChartOptions');

var _ChartOptions2 = _interopRequireDefault(_ChartOptions);

var _ImageOptions = require('./ImageOptions');

var _ImageOptions2 = _interopRequireDefault(_ImageOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ComponentOptions = function (_React$Component) {
	_inherits(ComponentOptions, _React$Component);

	function ComponentOptions() {
		_classCallCheck(this, ComponentOptions);

		return _possibleConstructorReturn(this, (ComponentOptions.__proto__ || Object.getPrototypeOf(ComponentOptions)).apply(this, arguments));
	}

	_createClass(ComponentOptions, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'report-options' },
				this.renderOptions.bind(this)()
			);
		}
	}, {
		key: 'renderOptions',
		value: function renderOptions() {

			switch (this.props.type) {

				case 'chart':
					return this.chartOptions.bind(this)();

				case 'text':
					return this.textOptions.bind(this)();

				case 'images':
					return this.imageOptions.bind(this)();

			}
		}
	}, {
		key: 'chartOptions',
		value: function chartOptions() {
			var _props = this.props,
			    type = _props.type,
			    props = _objectWithoutProperties(_props, ['type']);

			return _react2.default.createElement(_ChartOptions2.default, props);
		}
	}, {
		key: 'textOptions',
		value: function textOptions() {
			return null;
		}
	}, {
		key: 'imageOptions',
		value: function imageOptions() {
			var _props2 = this.props,
			    type = _props2.type,
			    props = _objectWithoutProperties(_props2, ['type']);

			return _react2.default.createElement(_ImageOptions2.default, props);
		}
	}]);

	return ComponentOptions;
}(_react2.default.Component);

exports.default = ComponentOptions;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/ComponentOptions.js
// module id = 574
// module chunks = 0